import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeviceListComponent } from './component/device/device-list/device-list.component';
import { WorkspacesListComponent } from './component/workspace/workspaces-list/workspaces-list.component';
import { StoragePipeModule } from '@shared/utils';
import { InviteListComponent } from './component/invite/list/invite-list.component';
import { InviteEditorComponent } from './component/invite/editor/invite-editor.component';
import { WorkspaceSelectorComponent } from './component/workspace/widgets/workspace-selector/workspace-selector.component';
import { UserCreatorComponent } from './component/user/creator/user-creator.component';
import { UserEditorComponent } from './component/user/editor/user-editor.component';
import { UserListComponent } from './component/user/list/user-list.component';
import { WorkspaceEditorComponent } from './component/workspace/workspace-editor/workspace-editor.component';
import { WorkspaceDetailComponent } from './component/workspace/workspace-detail/workspace-detail.component';
import { WorkspaceMembersComponent } from './component/workspace/workspace-members/workspace-members.component';

@NgModule({
  imports: [
    CommonModule,
    StoragePipeModule,
    WorkspacesListComponent,
    DeviceListComponent,
    InviteListComponent,
    InviteEditorComponent,
    WorkspaceSelectorComponent,
    UserCreatorComponent,
    UserEditorComponent,
    UserListComponent,
    WorkspaceDetailComponent,
    WorkspaceEditorComponent,
    WorkspaceMembersComponent,
  ],
  exports: [
    WorkspacesListComponent,
    DeviceListComponent,
    InviteListComponent,
    InviteEditorComponent,
    WorkspaceSelectorComponent,
    UserCreatorComponent,
    UserEditorComponent,
    UserListComponent,
    WorkspaceDetailComponent,
    WorkspaceEditorComponent,
    WorkspaceMembersComponent,
  ],
})
export class ManagementUiModule {}
